export default {
      id: "arrow-left-usage",
      viewBox: "0 0 40 14",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }